<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">
                {{$t('Bareme.etape1.titreFormulaire')}}
            </div>
            <div class="panel-body">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'section-form-contenu',
};
</script>

<style scoped>

</style>
